// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardlogin-chart-container {
    display: flex; /* Optional: If you want alignment */
    justify-content: center; /* Center the chart horizontally */
     /* Add space below the container */
    width: 90%;
    height:60%;
    padding:0;
}

.dashboardloginchartgray-box {
    background-color: #ffffff; /* White background */
    border: 1px solid #d3d3d3; /* Light border */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
    border-radius: 8px; /* Rounded corners */
    padding: 10px; /* Inner padding */
    max-width: 900px; /* Slightly increase the maximum width */
    width: 100%; /* Let the width take up more of the parent container */
    margin: 0 auto; /* Center the box horizontally */
}

.dashboardlogin-chart {
    text-align: center; /* Center-align the content */
    
}

.dashboardlogin-chart h3 {
    
    font-family: Arial, sans-serif;
    color: #333;
    font-size: 16px;
    margin-bottom: 10px;
    margin-left:80%;
}


.dashboardlogin-chart h3 {
    font-family: Arial, sans-serif;
    color: #333; /* Dark text color */
    font-size: 16px; /* Adjust font size */
    margin-bottom: 10px; /* Space below the title */
}

.dashboardloginchartgray-box canvas {
    max-height: 250px; /* Limit the height of the chart */
    height: 100%; /* Ensure the chart resizes properly */
    width: 100%; /* Make the chart responsive */
}
`, "",{"version":3,"sources":["webpack://./src/components/MyDashboard/LoginChart.css"],"names":[],"mappings":"AAAA;IACI,aAAa,EAAE,oCAAoC;IACnD,uBAAuB,EAAE,kCAAkC;KAC1D,kCAAkC;IACnC,UAAU;IACV,UAAU;IACV,SAAS;AACb;;AAEA;IACI,yBAAyB,EAAE,qBAAqB;IAChD,yBAAyB,EAAE,iBAAiB;IAC5C,0CAA0C,EAAE,kBAAkB;IAC9D,kBAAkB,EAAE,oBAAoB;IACxC,aAAa,EAAE,kBAAkB;IACjC,gBAAgB,EAAE,wCAAwC;IAC1D,WAAW,EAAE,uDAAuD;IACpE,cAAc,EAAE,gCAAgC;AACpD;;AAEA;IACI,kBAAkB,EAAE,6BAA6B;;AAErD;;AAEA;;IAEI,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,8BAA8B;IAC9B,WAAW,EAAE,oBAAoB;IACjC,eAAe,EAAE,qBAAqB;IACtC,mBAAmB,EAAE,0BAA0B;AACnD;;AAEA;IACI,iBAAiB,EAAE,kCAAkC;IACrD,YAAY,EAAE,sCAAsC;IACpD,WAAW,EAAE,8BAA8B;AAC/C","sourcesContent":[".dashboardlogin-chart-container {\n    display: flex; /* Optional: If you want alignment */\n    justify-content: center; /* Center the chart horizontally */\n     /* Add space below the container */\n    width: 90%;\n    height:60%;\n    padding:0;\n}\n\n.dashboardloginchartgray-box {\n    background-color: #ffffff; /* White background */\n    border: 1px solid #d3d3d3; /* Light border */\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n    border-radius: 8px; /* Rounded corners */\n    padding: 10px; /* Inner padding */\n    max-width: 900px; /* Slightly increase the maximum width */\n    width: 100%; /* Let the width take up more of the parent container */\n    margin: 0 auto; /* Center the box horizontally */\n}\n\n.dashboardlogin-chart {\n    text-align: center; /* Center-align the content */\n    \n}\n\n.dashboardlogin-chart h3 {\n    \n    font-family: Arial, sans-serif;\n    color: #333;\n    font-size: 16px;\n    margin-bottom: 10px;\n    margin-left:80%;\n}\n\n\n.dashboardlogin-chart h3 {\n    font-family: Arial, sans-serif;\n    color: #333; /* Dark text color */\n    font-size: 16px; /* Adjust font size */\n    margin-bottom: 10px; /* Space below the title */\n}\n\n.dashboardloginchartgray-box canvas {\n    max-height: 250px; /* Limit the height of the chart */\n    height: 100%; /* Ensure the chart resizes properly */\n    width: 100%; /* Make the chart responsive */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
